// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b91625b0","455":"e10ddde0","977":"afaff950"}[chunkId] + ".chunk.js";
};